import { createLoading } from "../../../../utils/loading";
import i18n from "../../../../i18n";
import lodash from "lodash";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { modalStyleForm } from "../../../../utils/constant";
import { addModal } from "../../../../app.logic";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { validateError } from "../../../../utils/validate";
import { conditionFormChecker, initUseForm, putField } from "../../../../utils/form";
import {
    createFieldInput
} from "../../../../components/input/template-builder/template-builder.logic";
import { callGenerateQRCode, callSurveyResponseLink } from "../survey.logic";

export const { isLoading, setIsLoading } = createLoading();

export const ShareSurveyForm = defineAsyncComponent(() => import("./ShareSurveyForm"));

export const openModalForm = ({ props, onOk, bind, data }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.surveyAnswer.modal.title"),
                width: "750px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ShareSurveyForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
                refOriginId={data?.id}
            ></ShareSurveyForm>
        )
    });
    return options;
};

export const createForm = () => {
    return {
        qrCode: null,
    };
};

export const createRules = () => {
    return {

    };
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page }))
        .then(() => loadDefaultForm({ props, data }))
        .then(() => {
            const promises = [
                callGenerateQRCode({ qrGenerateInfo: { text: modelRef.link, width: 200, height: 200} })
            ]
            return Promise.all(promises)
        })
        .then((res) => {
            modelRef.qrCode = res[0]
        })
        .then(() => initUseForm({ props, data, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data }) => {
    const { refOriginId } = props;
    const { useForm } = data;
    const { modelRef } = useForm;

    const promises = [
        callSurveyResponseLink({ id: refOriginId }),
    ];
    return Promise.all(promises).then((arr) => {
        modelRef.link = arr[0]
    })
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};

export const createField = ({ props, data, key }) => {
    // const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}link`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 2 }, wrapperCol: { xs: 24, md: 22 } }),
                label: () => `${i18n.global.t("model.survey.modal.link")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.link,
                            "onUpdate:value": (value) => (model.link = value),
                            readonly: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            {
                key: `${prefix}qrCode`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 }, align: 'center' }),
                formItemRender: () => {
                    const img = <img class="w-100" src={`data:image/jpeg;base64,${model.qrCode}`} alt={"qrCode"}/>
                    return <div>{img}</div>
                },
            },
        ]
    })
}
